class TickerBar extends HTMLElement {
  connectedCallback() {
    // The outer wrapper carries the bar's background/height; fall back to the
    // component itself if the markup ever changes.
    this.bar = this.closest(".ticker-bar") || this;

    // Keep --ticker-height in sync with the rendered bar height so the sticky
    // header (or anything else) can offset itself by the live measurement.
    this.resizeObserver = new ResizeObserver(() => this.updateHeight());
    this.resizeObserver.observe(this.bar);

    // Wait for layout/images so width measurements are accurate.
    if (document.readyState === "complete") {
      this.fill();
    } else {
      window.addEventListener("load", () => this.fill(), { once: true });
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    document.documentElement.style.removeProperty("--ticker-height");
  }

  updateHeight() {
    const height = this.bar.offsetHeight;
    document.documentElement.style.setProperty("--ticker-height", `${height}px`);
  }

  fill() {
    const tracks = this.querySelectorAll(".ticker-bar__track");
    if (!tracks.length) return;

    const source = tracks[0];
    const originals = Array.from(source.children).map((node) => node.cloneNode(true));
    if (!originals.length) return;

    // Each track must be at least as wide as the viewport, otherwise the
    // translateX(-100%) loop would expose a gap. Clone the message set until
    // a single track comfortably overflows the visible area.
    tracks.forEach((track) => {
      let guard = 0;
      while (track.scrollWidth < this.offsetWidth && guard < 20) {
        originals.forEach((node) => track.appendChild(node.cloneNode(true)));
        guard += 1;
      }
    });
  }
}

customElements.define("ticker-bar", TickerBar);
